import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { updateUserAction } from '../../../store/actions/user/UserActions';

function ChangePassword(props) {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.auth);
    const currentUser = auth?.user;
    
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [formErrors, setFormErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Clear errors when user starts typing
        setFormErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        const { password, confirmPassword } = formData;
        const errors = {};

        // Validation
        if (!password.trim()) {
            errors.password = "New password is required.";
        } else if (password.length < 6) {
            errors.password = "Password must be at least 6 characters long.";
        }

        if (!confirmPassword.trim()) {
            errors.confirmPassword = "Please confirm your password.";
        } else if (password !== confirmPassword) {
            errors.confirmPassword = "Passwords do not match.";
        }

        setFormErrors(errors);

        if (Object.keys(errors).length > 0) return;

        setIsLoading(true);
        
        try {
            const response = await dispatch(updateUserAction(currentUser._id, {
                password: password
            }));

            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Password changed successfully!',
                    timer: 2000,
                    showConfirmButton: false
                });
                handleClose();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data?.msg || 'Failed to change password'
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error?.response?.data?.msg || 'An unexpected error occurred'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setShowModal(false);
        setFormData({
            password: '',
            confirmPassword: ''
        });
        setFormErrors({});
    };

    const handleOpen = () => {
        setShowModal(true);
    };

    return (
        <>
            <button className="dropdown-item ai-icon" onClick={handleOpen}>
                <svg
                    id="icon-lock" xmlns="http://www.w3.org/2000/svg"
                    className="text-danger" width={18} height={18} viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                >
                    <rect x={3} y={11} width={18} height={11} rx={2} ry={2} />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    <circle cx={12} cy={16} r={1.5} />
                </svg>
                <span className="ms-2">Change Password</span>
            </button>

            <Modal className="modal fade" show={showModal} onHide={handleClose}>
                <form onSubmit={handleSubmit}>
                    <div className="modal-header">
                        <h4 className="modal-title fs-20">Change Password</h4>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="add-contact-box">
                            <div className="add-contact-content">
                                <div className="form-group mb-3">
                                    <label>New Password</label>
                                    <input 
                                        type="password" 
                                        className={`form-control ${formErrors.password ? 'is-invalid' : ''}`}
                                        name="password" 
                                        value={formData.password} 
                                        onChange={handleChange} 
                                        placeholder="Enter new password"
                                        disabled={isLoading}
                                    />
                                    {formErrors.password && <div className="invalid-feedback">{formErrors.password}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <label>Confirm Password</label>
                                    <input 
                                        type="password" 
                                        className={`form-control ${formErrors.confirmPassword ? 'is-invalid' : ''}`}
                                        name="confirmPassword" 
                                        value={formData.confirmPassword} 
                                        onChange={handleChange} 
                                        placeholder="Confirm new password"
                                        disabled={isLoading}
                                    />
                                    {formErrors.confirmPassword && <div className="invalid-feedback">{formErrors.confirmPassword}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Changing...
                                </>
                            ) : (
                                'Change Password'
                            )}
                        </button>
                        <button 
                            type="button" 
                            onClick={handleClose} 
                            className="btn btn-secondary"
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </Modal>
        </>
    );
}

export default ChangePassword;

